module.exports = __webpack_public_path__ + "static/media/Logo.41704219.png";